import React, { useState } from "react";
import algoliasearch from "algoliasearch/lite";
import Parser from "html-react-parser";
import Modal from "./components/Modal";
import SearchResults from "./components/SearchResults";
import { Search as SearchIcon } from "./components/Icons";
const searchClient = algoliasearch(
  "TUGZ383SI1",
  "1fcb038e282e8efe758fcda5ec6f3941"
);

const App = ({ children }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    const body = document.querySelector("body");
    body.style.overflowY = !modalVisible ? "hidden" : "auto";
    setModalVisible(modalVisible => !modalVisible);
  };

  return (
    <div className="tw-relative tw-flex tw-items-center tw-justify-center tw-font-sans">
      <button
        className="tw-bg-transparent tw-border-0 tw-flex tw-items-center tw-cursor-pointer tw-p-0"
        style={{
          font: "inherit",
          color: "inherit"
        }}
        onClick={toggleModal}
      >
        <SearchIcon />
        {children && <span className="tw-ml-2">{Parser(children)}</span>}
      </button>
      <Modal visible={modalVisible} onToggleVisibility={toggleModal}>
        <SearchResults
          searchClient={searchClient}
          visible={modalVisible}
          onToggleVisibility={() => setModalVisible(false)}
        />
      </Modal>
    </div>
  );
};

export default App;
